import pinIdleSvg from 'src/assets/pin-idle.svg?raw';
import { COLOR_VALUES } from 'src/services/constants';
import SvgMarker from './SvgMarker';

export default class IdleSvgMarker extends SvgMarker {
  constructor() {
    super(pinIdleSvg, {
      height: 60,
      width: 60,
      innerColor: COLOR_VALUES.DARK,
      outerColor: COLOR_VALUES.POSITIVE,
    });
  }
}
